import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const DateBox = styled.span`
  display: flex;
  align-items: center;
  height: 32px;
  margin-right: 10px;
  font-size: 14px;
  color: ${COLORS.gray60};
`;

export default DateBox;
